import * as z from "zod";

const timePeriodSchema = z.enum(["week", "month", "quarter", "all"]);

export const selfServeOnboardingConversionTrendSchema = z.object({
  dataPoints: z.array(
    z.object({
      period: z.string(), // e.g., "2024-01", "Q1 2024", "Week of Jan 1"
      conversionRate: z.number().min(0).max(100),
      totalStarted: z.number().int().min(0),
      completedToStep: z.number().int().min(0),
    }),
  ),
  stepName: z.string(),
});

export const getSelfServeOnboardingConversionTrend = {
  name: "getSelfServeOnboardingConversionTrend" as const,
  input: z.object({
    timePeriod: timePeriodSchema,
    stepKey: z.string(),
    filterLowIntent: z.boolean().optional(),
  }),
  output: selfServeOnboardingConversionTrendSchema,
};

export type SelfServeOnboardingConversionTrend = z.infer<
  typeof selfServeOnboardingConversionTrendSchema
>;
export type GetSelfServeOnboardingConversionTrendInput = z.infer<
  typeof getSelfServeOnboardingConversionTrend.input
>;
export type GetSelfServeOnboardingConversionTrendOutput = z.infer<
  typeof getSelfServeOnboardingConversionTrend.output
>;
